import React from 'react';
// import logo from './logo.svg';
import './App.css';
import Home from './router.js'
// import Common from './pub_com/common.jsx'
function App() {
  return (
    <div className="App">
      <Home></Home>
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js